import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';

export default class TopNavbarFundsIndexComponent extends Component {
  classNames = ['flex-grow-1', 'd-flex'];

  <template>
    <div class='nav-item'>
      <LinkTo
        @route='funds.fund'
        @model='selected-fund'
        class='btn btn-outline-brand'
      >
        Dashboard
      </LinkTo>
    </div>
  </template>
}
